import { useTranslation } from 'react-i18next';
import React from 'react';
import { useQuery } from '@apollo/client';
import * as queries from '../queries';
import '../CSS/Admin.css'; // Assuming you have a CSS file for styling
import { FaLocationDot } from "react-icons/fa6";
import { MdAccessTimeFilled } from "react-icons/md";
import bidClient from '../bidClient.js';
const AuctionSum = ({ auctionID, origin }) => {
  const { t } = useTranslation();
  const { loading: loadingAuction, error: errorAuction, data: dataAuction } = useQuery(queries.GET_AUCTIONBYID, {
    variables: { AuctionID: auctionID },
  });

  const { loading: loadingLiveItem, error: errorLiveItem, data: auctionSum } = useQuery(queries.GETAUCTIONSUM, {
    client: bidClient,
    variables: { AuctionID: auctionID, AuctionID2: auctionID },
    pollInterval: 10000,
  });

  function formatDateTime(dateTimeString) {
    if (!dateTimeString) return '';
    const date = new Date(dateTimeString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  if (loadingAuction || loadingLiveItem) return <p>{t('Loading...')}</p>;
  if (errorAuction) return <p>{t('Error:')}{errorAuction.message}</p>;
  if (errorLiveItem) return <p>{t('Error:')}{errorLiveItem.message}</p>;

  const auction = dataAuction?.oneAuctions;
  const liveAuctionSum = auctionSum?.allOnlineAuction?.aggregateData[0];

  if (!auction || !liveAuctionSum) return <p>{t('No data available')}</p>;

  return (
    <div className={`margin-bottom-1em ${origin !== 'AuctionDashBoard' && 'auctionSum_container_AuctionDashBoard'}`}>
      {origin !== 'AuctionDashBoard' && (
        <>
          <div className='dashboard-operation-part'>
            <div className='a-tag-btn dashboard-main-btn'>
              <div className='flex-row-direction align-center dashboard-main-btn-right'>
                <a href={`/admin/auctions/current/${auction.AuctionID}/livelots`}>
                  <div className='currentAuction-name-location'>
                    {auction.AuctionName}
                  </div>
                </a>
                {/* {auctionSum.allBidList?.aggregateData[0]?.countBidListID && (
                  <a className='margin-right-1em' href={`/admin/auctions/current/${auctionID}/liveRegistration`}>
                    <div className='AmountItemNeedToDo shadow-[0_4px_12px_rgba(0,0,0,0.3)]'>
                      <span>{auctionSum.allBidList.aggregateData[0].countBidListID}</span>
                    </div>
                  </a>
                )} */}
              </div>
            </div>
          </div>
          <div className='flex flex-row-direction gap-4 p-2'>
            <div className='w-[20%] max-w-[10vw] min-w-[50px]'>
              <img src='/picture/logPlaceholder.jpg' style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }} />
            </div>
            <div className='flex flex-col gap-4'>
              <div className='flex flex-row-direction items-baseline gap-2'>
                <FaLocationDot />
                <address>
                  {auction.LocationCode} --- {auction.UnitNum} {auction.Street} {auction.City} {auction.Province}
                </address>
              </div>

              <div className='flex flex-row-direction items-baseline gap-2'>
                <MdAccessTimeFilled />
                <div>
                  <span className='whitespace-nowrap'>{formatDateTime(auction.OpeningTime)}</span>
                  --
                  <span className='whitespace-nowrap'>{formatDateTime(auction.ClosedTime)}</span>
                </div>
              </div>

            </div>
          </div>
        </>

      )}
      <div className={`overflow-auto ${origin !== 'AuctionDashBoard' && 'auctionSum_container_table_AuctionDashBoard'}`}>
        <table>
          <thead>
            <tr>
              <th>{t('Total Lots')}</th>
              <th>{t('Registrations')}</th>
              <th>{t('Views')}</th>
              <th>{t('Total Bids')}</th>
              <th>{t('High Bid')}</th>
              <th>{t('Max Bid')}</th>
              <th>{t('Average High Bid')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-label="Total Lots">{liveAuctionSum.countLotID}</td>
              <td data-label="Registrations">{auctionSum.allAllowAuction.aggregateData[0]?.countID}</td>
              <td data-label="Views">{liveAuctionSum.sumViews}</td>
              <td data-label="Total Bids">{liveAuctionSum.sumBids}</td>
              <td data-label="High Bid">{liveAuctionSum.sumHighBid}</td>
              <td data-label="Max Bid">{liveAuctionSum.sumMaxBid}</td>
              <td data-label="Average High Bid">{liveAuctionSum.avgHighBid.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuctionSum;